export const SIDEBAR_EXPERIENCE_NAME = 'conditional-formatting';
